module.exports = "/assets/data/d0ed29676c095d2a8dd9b48ca2018be4-WR10.data.json";